/**
 * Парсинг inline-разметки: **bold**, [N] → ссылка по citeIndex источника.
 */

export function getCitableSources(sources) {
    return (sources || []).filter((s) => s && s.url)
}

/**
 * [N] → источник с citeIndex === N (сквозная нумерация с бэкенда).
 * Для старых сообщений без citeIndex — N-й URL в порядке прихода.
 */
export function resolveCitationSource(index, sources) {
    const n = Number(index)
    if (!Number.isFinite(n) || n < 1) return null

    const withIndex = (sources || []).find(
        (s) => s && s.url && Number(s.citeIndex) === n,
    )
    if (withIndex) return withIndex

    const citable = getCitableSources(sources)
    return citable[n - 1] || null
}

/**
 * @param {string} value
 * @param {Array} sources — message.sources
 */
export function parseInlineCitations(value, sources) {
    const parts = []
    const regex = /\*\*([^*]+)\*\*|\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)|\[(\d{1,3})\]/g
    let lastIndex = 0
    let match
    const text = String(value || '')

    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push({ text: text.slice(lastIndex, match.index), bold: false })
        }
        if (match[1] !== undefined) {
            parts.push({ text: match[1], bold: true })
        } else if (match[2] !== undefined && match[3] !== undefined) {
            parts.push({
                cite: true,
                index: match[2],
                url: match[3],
                title: match[2],
            })
        } else if (match[4] !== undefined) {
            const idx = Number(match[4])
            const src = resolveCitationSource(idx, sources)
            if (src?.url) {
                parts.push({
                    cite: true,
                    index: idx,
                    url: src.url,
                    title: src.title || '',
                })
            } else {
                parts.push({ text: `[${idx}]`, bold: false })
            }
        }
        lastIndex = regex.lastIndex
    }
    if (lastIndex < text.length) {
        parts.push({ text: text.slice(lastIndex), bold: false })
    }
    return parts.length ? parts : [{ text, bold: false }]
}
